import { TransportOperationModule } from './../transport-operation/transport-operation.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SystemSettingRoutingModule } from './system-setting-routing.module';
import { UserGroupSubscriptionMaintenanceComponent } from './page/user-group-subscription-maintenance/user-group-subscription-maintenance.component';
import { LaaSSharedModule } from 'src/app/shared/laas-shared.module';
import { TermsMaintenanceComponent } from '../setting/pages/terms-maintenance/terms-maintenance.component';

@NgModule({
  declarations: [
    UserGroupSubscriptionMaintenanceComponent,
    TermsMaintenanceComponent],
  imports: [
    CommonModule,
    SystemSettingRoutingModule,
    LaaSSharedModule,
    TransportOperationModule
  ]
})
export class SystemSettingModule { }
